var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2029(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-20.7, 1)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(9.519824, 11.608218) scale(-1, 1) translate(-9.519824, -11.608218)",
    d: "M10.3158606,23.216435 C9.97782625,23.216435 9.62361909,23.2061938 9.25323912,23.1857112 C3.3886619,22.8818866 0.394187723,16.9248759 0.133486697,14.4908653 C-0.0689102466,12.3342635 -0.0410776059,10.1622671 0.216514678,8.01154938 C0.63233794,4.6387548 8.63001675,0.326493564 9.56485031,0.149660812 C10.0432008,0.0598789318 12.5005557,-0.338506824 13.7835601,0.702689881 C13.8354953,0.745361877 18.942912,5.20202515 19.0235482,8.36316662 L19.0235482,8.36316662 C19.0577161,9.66722283 19.0307235,11.299 19.0050976,12.8761569 C18.9842552,14.1972819 18.9640961,15.4433042 18.9828884,16.3445368 C19.0132979,17.832936 18.2728796,19.4749544 16.7817928,21.2262131 C16.4763318,21.5812441 14.8390063,23.216435 10.3158606,23.216435 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.884797, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-8.884797, -18.000000) translate(0.884797, 10.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 3.53111281,
    y1: 4.20727323,
    x2: 15.1316061,
    y2: 20.2495946
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2029);
export default __webpack_public_path__ + "static/media/20-29.26206b34377bed6e32c735b1adb3cee5.svg";
export { ForwardRef as ReactComponent };